import { z } from 'zod';
import { checkPassword } from './passwords';

export const MAX_NOTE_LENGTH = 10000;

export const createNoteSchema = z.object({
  content: z.string()
    .min(1, 'Please enter the note content')
    .max(MAX_NOTE_LENGTH, `Note content cannot exceed ${MAX_NOTE_LENGTH} characters`),
  password: z.string()
    .min(6, 'Password must be at least 6 characters')
    .refine(
      async (password) => {
        if (!password) return true;
        const { exposed } = await checkPassword(password);
        return !exposed;
      },
      'This password has been exposed in data breaches. Please choose a different one.'
    )
    .optional(),
  expiresInDays: z.number()
    .min(1, 'Note must expire after at least 1 day')
    .max(30, 'Note cannot expire after more than 30 days'),
  viewLimit: z.number()
    .min(1, 'View limit must be at least 1')
    .nullable()
    .optional(),
});

export const accessNoteSchema = z.object({
  password: z.string()
    .min(6, 'Password must be at least 6 characters')
    .or(z.literal(''))
});